'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var legacyParse_1 = require('../legacyParse');
function legacyParseMap(array) {
  return array.map(function (item) {
    return legacyParse_1.default(item);
  });
}
exports.default = legacyParseMap;
